/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jobticketbestaetigt2Inputs */



/**

* @param {_Field_Jobticketbestaetigt2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jobticketbestaetigt2 = /** @type {((inputs?: _Field_Jobticketbestaetigt2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jobticketbestaetigt2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jobticket Bestätigt")
});
export { _field_jobticketbestaetigt2 as "_field_jobTicketBestaetigt" }